import React from 'react'
import { Tag, Tooltip } from 'antd'

export const PAYMENT_GATEWAY_COMMERCEPAY = "commercePay";
export const PAYMENT_GATEWAY_PAYDIBS = "paydibs";

export const PAYMENT_GATEWAYS = {
  [PAYMENT_GATEWAY_COMMERCEPAY]: {
    label: "CommercePay",
    key: PAYMENT_GATEWAY_COMMERCEPAY,
    color: "green",
    title: "CommercePay"
  },
  [PAYMENT_GATEWAY_PAYDIBS]: {
    label: "Paydibs",
    key: PAYMENT_GATEWAY_PAYDIBS,
    color: "blue",
    title: "Paydibs"
  },
};

export const PaymentGatewayTag = (statusKey) => {
  const paymentProvider = PAYMENT_GATEWAYS[statusKey];

  if (paymentProvider) {
    return (
      <Tooltip placement="topLeft" title={paymentProvider.title}>
        <Tag color={paymentProvider.color}>{paymentProvider.label}</Tag>
      </Tooltip>
    );
  }

  return null;
};

